import { callApi } from "@/api/api-core";

export const fetchInfo = function(ownerHandlesFailure) {
    return callApi(
        "POST",
        "v1/products/dsborangeticket/info",
        undefined,
        ownerHandlesFailure
    );
};

export const calculatePrice = function(
    tripId,
    passengers,
    ownerHandlesFailure
) {
    return callApi(
        "POST",
        "v1/products/dsborangeticket/price/calculate",
        {
            tripId,
            passengers
        },
        ownerHandlesFailure
    );
};

export const createOrder = function(
    productVariantId,
    passengers,
    seating,
    ownerHandlesFailure
) {
    return callApi(
        "POST",
        "v1/products/dsborangeticket/order",
        {
            productVariantId,
            passengers,
            seating,
            salesChannelIdentifier: "Webshop"
        },
        ownerHandlesFailure
    );
};
